var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73127 20.3599C-0.291935 26.3025 -0.291934 35.9479 5.73127 41.8904C8.26357 44.3888 11.6148 45.9381 15.1745 46.2824L15.1745 46.2824L15.1831 46.2832C16.5281 46.3956 17.6921 45.4264 17.8288 44.1226L17.8289 44.1226L17.83 44.1107C17.944 42.7837 16.9615 41.6353 15.6401 41.5004L15.6358 41.5C13.1932 41.2667 10.8945 40.2095 9.16479 38.5029C5.04048 34.4338 5.04048 27.8165 9.16479 23.7475L17.5235 15.5007C21.6478 11.4316 28.3549 11.4316 32.4792 15.5007C36.6035 19.5697 36.6035 26.187 32.4792 30.2561L28.2999 34.3795C27.3588 35.308 27.3588 36.8385 28.2999 37.767C29.241 38.6955 30.7923 38.6955 31.7334 37.767L35.9128 33.6436C41.936 27.7011 41.936 18.0557 35.9128 12.1132C29.8895 6.17062 20.1132 6.17062 14.09 12.1132L5.73127 20.3599Z",
    fill: "#3E97FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0856 25.2911C18.0624 31.2336 18.0624 40.879 24.0856 46.8216C30.1088 52.7641 39.8851 52.7641 45.9083 46.8216L54.2671 38.5748C60.2905 32.632 60.2896 22.9876 54.2851 17.0291L54.2838 17.0278C51.7513 14.5293 48.399 12.9793 44.8204 12.652L44.8152 12.6516C43.4849 12.5403 42.2838 13.4796 42.1684 14.824C42.0544 16.1511 43.0368 17.2995 44.3582 17.4343L44.3625 17.4348C46.8051 17.668 49.1038 18.7253 50.8335 20.4318C54.9578 24.5009 54.9578 31.1182 50.8335 35.1872L42.4748 43.434C38.3505 47.5031 31.6434 47.5031 27.5191 43.434C23.3948 39.365 23.3948 32.7477 27.5191 28.6786L31.6985 24.5552C32.6396 23.6267 32.6396 22.0962 31.6985 21.1677C30.7574 20.2392 29.206 20.2392 28.265 21.1677L24.0856 25.2911Z",
    fill: "#404350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo-2.fd42d58931a24235b905d2c1fda54f0d.svg";
export { ForwardRef as ReactComponent };